/**
 * 获取月预警
 */
export function getMonthWarningOption () {
  return {
    grid: {
      left: 50,
      right: 50,
      top: 50,
      bottom: 40
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      type: 'category',
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      },
      data: ['台风', '寒冷', '雷雨\n大风', '森林\n火险', '暴雨', '道路\n结冰', '灰霾', '冰雹']
    },
    yAxis: {
      type: 'value',
      name: '（次数）',
      nameTextStyle: {
        fontSize: '0.9rem',
        align: 'right',
        color: '#FFF'
      },
      splitLine: {
        show: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    series: [
      {
        data: [12, 20, 15, 8, 7, 11, 13, 2],
        type: 'bar',
        barWidth: 20,
        showBackground: true,
        backgroundStyle: {
          color: 'rgba(31, 44, 73, 0.87)',
          borderRadius: 10
        },
        itemStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 1,
            x2: 0,
            y2: 0,
            colorStops: [
              {
                offset: 0,
                color: '#2D74F5'
              },
              {
                offset: 1,
                color: '#53A4FA'
              }
            ],
            global: false
          },
          barBorderRadius: [10, 10, 0, 0]
        }
      }
    ]
  }
}
/**
 * 获取年预警
 */
export function getYearWarningOption () {
  return {
    legend: {
      orient: 'vertical',
      right: 10,
      icon: 'circle',
      type: 'scroll',
      itemGap: 15,
      textStyle: {
        color: '#FFF'
      }
    },
    tooltip: {
      trigger: 'item'
    },
    series: [
      {
        name: '当年发布预警信号',
        roseType: 'radius',
        type: 'pie',
        radius: ['15%', '75%'],
        center: ['40%', '50%'],
        // roseType: 'area',
        label: {
          color: '#FFF',
          fontSize: '0.9rem'
        },
        itemStyle: {
          borderRadius: 0,
          borderWidth: 2,
          borderColor: 'rgba(101, 182, 246, 0.22)'
        },
        data: [
          { value: 40, name: '台风' },
          { value: 38, name: '寒冷' },
          { value: 32, name: '雷雨大风' },
          { value: 30, name: '森林火险' },
          { value: 28, name: '暴雨' },
          { value: 26, name: '道路结冰' },
          { value: 22, name: '高温' },
          { value: 18, name: '灰霾' },
          { value: 15, name: '冰雹' }
        ]
      }
    ]
  }
}
